import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import './App.css';
import { ConfigProvider } from 'antd';
import { customTheme } from './theme/theme';
import { AppLayout } from './components/app-layout';
import { WidgetProvider } from './context/widget';

const App: React.FC = () => {
  return (
    <ConfigProvider theme={customTheme}>
      <WidgetProvider>
        <div className='App'>
          <AppLayout />
        </div>
      </WidgetProvider>
    </ConfigProvider>
  );
};

export default App;
